/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Спецификация АПИ управления сущностью User
 */

/**
 * Сервис управления пользователями
 */
export class UserServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод удаления единичной сущности User по ключу
   */
  DeleteUser = (req: DeleteUserRequestDto, init?: RequestInit): Promise<DeleteUserResponseDto> => {
    return fm.request<DeleteUserRequestDto, DeleteUserResponseDto>(`${this.host}/device/api/v1/user/${encodeURIComponent(req.username)}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка сущностей User по фильтру
   */
  GetUserList = (req?: GetUserListRequestDto, init?: RequestInit): Promise<GetUserListResponseDto> => {
    return fm.request<GetUserListRequestDto, GetUserListResponseDto>(`${this.host}/device/api/v1/user/list${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод замены имени пользователя
   */
  PostUserNameReplace = (req: PostUserNameReplaceRequestDto, init?: RequestInit): Promise<PostUserNameReplaceResponseDto> => {
    return fm.request<PostUserNameReplaceRequestDto, PostUserNameReplaceResponseDto>(`${this.host}/device/api/v1/user/${encodeURIComponent(req.username)}/name/replace`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод замены пароля пользователя
   */
  PostUserPasswordReplace = (req: PostUserPasswordReplaceRequestDto, init?: RequestInit): Promise<PostUserPasswordReplaceResponseDto> => {
    return fm.request<PostUserPasswordReplaceRequestDto, PostUserPasswordReplaceResponseDto>(`${this.host}/device/api/v1/user/${encodeURIComponent(req.username)}/password/replace`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод замены пароля пользователя.
   * Будут изменены только явно переданные в data.permission разрешения
   */
  PostUserPermissionReplace = (req: PostUserPermissionReplaceRequestDto, init?: RequestInit): Promise<PostUserPermissionReplaceResponseDto> => {
    return fm.request<PostUserPermissionReplaceRequestDto, PostUserPermissionReplaceResponseDto>(`${this.host}/device/api/v1/user/${encodeURIComponent(req.username)}/permission/replace`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод создания/редактирования сущности User
   */
  SaveUser = (req: SaveUserRequestDto, init?: RequestInit): Promise<SaveUserResponseDto> => {
    return fm.request<SaveUserRequestDto, SaveUserResponseDto>(`${this.host}/device/api/v1/user`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Запрос удаления единичной сущности User по ключу
 */
export type DeleteUserRequestDto = {
  /**
   * Имя пользователя
   */
  username: string
}
/**
 * Ответ на запрос удаления единичной сущности User по ключу
 */
export type DeleteUserResponseDto = {
}
/**
 * Запрос получения списка сущностей User по фильтру
 */
export type GetUserListRequestDto = {
}
/**
 * Ответ на запрос получения списка сущностей User по фильтру
 */
export type GetUserListResponseDto = {
  /**
   * Список User
   */
  data: UserResponseDto[]
}
/**
 * Запрос замены имени пользователя
 */
export type PostUserNameReplaceRequestDto = {
  /**
   * Имя пользователя
   */
  username: string
  /**
   * Поле на замену
   */
  data: PostUserNameReplaceRequestReplaceToDto
}
/**
 * Поле на замену
 */
export type PostUserNameReplaceRequestReplaceToDto = {
  /**
   * Имя пользователя
   */
  targetUsername: string
}
/**
 * Ответ на запрос замены имени пользователя
 */
export type PostUserNameReplaceResponseDto = {
}
/**
 * Запрос замены пароля пользователя
 */
export type PostUserPasswordReplaceRequestDto = {
  /**
   * Имя пользователя
   */
  username: string
  /**
   * Поле на замену
   */
  data: PostUserPasswordReplaceRequestReplaceToDto
}
/**
 * Поле на замену
 */
export type PostUserPasswordReplaceRequestReplaceToDto = {
  /**
   * Пароль
   */
  password?: string
}
/**
 * Ответ на запрос замены пароля пользователя
 */
export type PostUserPasswordReplaceResponseDto = {
}
/**
 * Запрос замены разрешений пользователя
 */
export type PostUserPermissionReplaceRequestDto = {
  /**
   * Имя пользователя
   */
  username: string
  /**
   * Поле на замену
   */
  data: PostUserPermissionReplaceRequestReplaceToDto
}
/**
 * Поле на замену
 */
export type PostUserPermissionReplaceRequestReplaceToDto = {
  /**
   * Права доступа
   */
  permission?: UserPermissionRequestDto[]
}
/**
 * Ответ на запрос замены разрешений пользователя
 */
export type PostUserPermissionReplaceResponseDto = {
}
/**
 * Запрос на создания/редактирование сущности User
 */
export type SaveUserRequestDto = {
  /**
   * Пользователь
   */
  data: UserRequestDto
}
/**
 * Ответ на запрос на создания/редактирование сущности User
 */
export type SaveUserResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Пользователь
   */
  readonly data: UserResponseDto
}>
/**
 * Пользователь
 */
export type UserRequestDto = {
  /**
   * Имя пользователя
   */
  username: string
  /**
   * Пароль.
   * Не возвращается с сервера.
   * TODO: в генерации сваггера не показывать INPUT_ONLY поля в ответах
   */
  password: string
  /**
   * Права доступа
   */
  permission?: UserPermissionRequestDto[]
}
/**
 * Пользователь
 */
export type UserResponseDto = {
  /**
   * Имя пользователя
   */
  username: string
  /**
   * Права доступа
   */
  permission: UserPermissionResponseDto[]
}
/**
 * Права доступа
 */
export type UserPermissionRequestDto = {
  /**
   * Имя разрешения
   */
  permissionName: string
  /**
   * Наличие разрешения
   */
  isEnabled: boolean
}
/**
 * Права доступа
 */
export type UserPermissionResponseDto = {
  /**
   * Имя разрешения
   */
  permissionName: string
  /**
   * Наличие разрешения
   */
  isEnabled: boolean
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос удаления единичной сущности User по ключу
   */
  "DeleteUserRequest": {
    "kind": "class",
    "text": "Запрос удаления единичной сущности User по ключу",
    "fields": {
      /**
       * Имя пользователя
       */
      "username": {
        "type": "string",
        "text": "Имя пользователя",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления единичной сущности User по ключу
   */
  "DeleteUserResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления единичной сущности User по ключу",
  },
  /**
   * Запрос получения списка сущностей User по фильтру
   */
  "GetUserListRequest": {
    "kind": "class",
    "text": "Запрос получения списка сущностей User по фильтру",
  },
  /**
   * Ответ на запрос получения списка сущностей User по фильтру
   */
  "GetUserListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка сущностей User по фильтру",
    "fields": {
      /**
       * Список User
       */
      "data": {
        "type": "User",
        "text": "Список User",
      },
    },
  },
  /**
   * Запрос замены имени пользователя
   */
  "PostUserNameReplaceRequest": {
    "kind": "class",
    "text": "Запрос замены имени пользователя",
    "fields": {
      /**
       * Имя пользователя
       */
      "username": {
        "type": "string",
        "text": "Имя пользователя",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Поле на замену
       */
      "data": {
        "type": "PostUserNameReplaceRequest.ReplaceTo",
        "text": "Поле на замену",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Поле на замену
   */
  "PostUserNameReplaceRequest.ReplaceTo": {
    "kind": "class",
    "text": "Поле на замену",
    "fields": {
      /**
       * Имя пользователя
       */
      "targetUsername": {
        "type": "string",
        "text": "Имя пользователя",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос замены имени пользователя
   */
  "PostUserNameReplaceResponse": {
    "kind": "class",
    "text": "Ответ на запрос замены имени пользователя",
  },
  /**
   * Запрос замены пароля пользователя
   */
  "PostUserPasswordReplaceRequest": {
    "kind": "class",
    "text": "Запрос замены пароля пользователя",
    "fields": {
      /**
       * Имя пользователя
       */
      "username": {
        "type": "string",
        "text": "Имя пользователя",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Поле на замену
       */
      "data": {
        "type": "PostUserPasswordReplaceRequest.ReplaceTo",
        "text": "Поле на замену",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Поле на замену
   */
  "PostUserPasswordReplaceRequest.ReplaceTo": {
    "kind": "class",
    "text": "Поле на замену",
    "fields": {
      /**
       * Пароль
       */
      "password": {
        "type": "string",
        "text": "Пароль",
      },
    },
  },
  /**
   * Ответ на запрос замены пароля пользователя
   */
  "PostUserPasswordReplaceResponse": {
    "kind": "class",
    "text": "Ответ на запрос замены пароля пользователя",
  },
  /**
   * Запрос замены разрешений пользователя
   */
  "PostUserPermissionReplaceRequest": {
    "kind": "class",
    "text": "Запрос замены разрешений пользователя",
    "fields": {
      /**
       * Имя пользователя
       */
      "username": {
        "type": "string",
        "text": "Имя пользователя",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Поле на замену
       */
      "data": {
        "type": "PostUserPermissionReplaceRequest.ReplaceTo",
        "text": "Поле на замену",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Поле на замену
   */
  "PostUserPermissionReplaceRequest.ReplaceTo": {
    "kind": "class",
    "text": "Поле на замену",
    "fields": {
      /**
       * Права доступа
       */
      "permission": {
        "type": "User.Permission",
        "text": "Права доступа",
      },
    },
  },
  /**
   * Ответ на запрос замены разрешений пользователя
   */
  "PostUserPermissionReplaceResponse": {
    "kind": "class",
    "text": "Ответ на запрос замены разрешений пользователя",
  },
  /**
   * Запрос на создания/редактирование сущности User
   */
  "SaveUserRequest": {
    "kind": "class",
    "text": "Запрос на создания/редактирование сущности User",
    "fields": {
      /**
       * Пользователь
       */
      "data": {
        "type": "User",
        "text": "Пользователь",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос на создания/редактирование сущности User
   */
  "SaveUserResponse": {
    "kind": "class",
    "text": "Ответ на запрос на создания/редактирование сущности User",
    "fields": {
      /**
       * Пользователь
       */
      "data": {
        "type": "User",
        "text": "Пользователь",
      },
    },
  },
  /**
   * Пользователь
   */
  "User": {
    "kind": "class",
    "text": "Пользователь",
    "fields": {
      /**
       * Имя пользователя
       */
      "username": {
        "type": "string",
        "text": "Имя пользователя",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Пароль.
       * Не возвращается с сервера.
       * TODO: в генерации сваггера не показывать INPUT_ONLY поля в ответах
       */
      "password": {
        "type": "string",
        "text": "Пароль.\nНе возвращается с сервера.\nTODO: в генерации сваггера не показывать INPUT_ONLY поля в ответах",
      },
      /**
       * Права доступа
       */
      "permission": {
        "type": "User.Permission",
        "text": "Права доступа",
      },
    },
  },
  /**
   * Права доступа
   */
  "User.Permission": {
    "kind": "class",
    "text": "Права доступа",
    "fields": {
      /**
       * Имя разрешения
       */
      "permissionName": {
        "type": "string",
        "text": "Имя разрешения",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Наличие разрешения
       */
      "isEnabled": {
        "type": "bool",
        "text": "Наличие разрешения",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
}